import { jsx as r } from "@emotion/react/jsx-runtime";
import { Stack as a } from "@partoohub/ui";
import { MenuPartnerLink as i } from "../MenuPartnerLink/MenuPartnerLink.js";
import { MenuAction as o } from "../MenuAction/MenuAction.js";
import { MenuExternalUrl as t } from "../MenuExternalUrl/MenuExternalUrl.js";
import { MenuItem as p } from "../MenuItem/MenuItem.js";
import { MENU_PARTNER_LINK as c } from "../MenuPartnerLink/MenuPartnerLink.types.js";
import { MENU_ACTION_TYPE as f } from "../MenuAction/MenuAction.types.js";
import { MENU_EXTERNAL_URL as E } from "../MenuExternalUrl/MenuExternalUrl.types.js";
const b = ({
  route: m,
  handleCloseMenu: n
}) => {
  let e;
  switch (m.type) {
    case E:
      e = /* @__PURE__ */ r(t, { route: m }, m.name);
      break;
    case f:
      e = /* @__PURE__ */ r(o, { route: m }, m.name);
      break;
    case c:
      e = /* @__PURE__ */ r(i, { route: m }, m.name);
      break;
    default:
      e = /* @__PURE__ */ r(p, { menuItem: m });
      break;
  }
  return /* @__PURE__ */ r(a, { as: "li", onClick: n, children: e }, m.name);
};
export {
  b as DynamicMenuRenderer
};
